export default {"src":"/_next/static/media/chevron-right.e970779a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};